import { ProductRepository } from '../../domain/repositories/ProductRepository';
import { ProductDto, ProductSearchDto } from '../dtos/ProductDto';

export class GetProductsUseCase {
  constructor(private readonly productRepository: ProductRepository) {}

  async execute(searchDto?: ProductSearchDto): Promise<ProductDto[]> {
    let products;

    if (searchDto?.query) {
      products = await this.productRepository.searchByName(searchDto.query);
    } else if (searchDto?.category) {
      products = await this.productRepository.findByCategory(searchDto.category);
    } else if (searchDto?.includeHidden === false) {
      products = await this.productRepository.findVisible();
    } else {
      products = await this.productRepository.findAll();
    }

    // Get variants for each product
    const productDtos: ProductDto[] = [];

    for (const product of products) {
      const variants = await this.productRepository.findVariantsByProductId(product.getId());

      const productDto: ProductDto = {
        id: product.getId().getUniqueIdentifier(),
        name: product.getName(),
        description: product.getDescription(),
        category: product.getCategory(),
        images: product.getImages(),
        slug: product.getSlug(),
        ingredients: product.getIngredients(),
        attributes: product.getAttributes(),
        allergenInfo: product.getAllergenInfo(),
        availability: product.getAvailability(),
        isVisible: product.isVisible(),
        createdAt: product.getCreatedAt().toISOString(),
        updatedAt: product.getUpdatedAt().toISOString(),
        variants: variants.map((variant) => ({
          id: variant.getId(),
          sku: variant.getSku(),
          productId: variant.getProductId().getUniqueIdentifier(),
          attributeCombination: variant.getAttributeCombination(),
          price: variant.getPrice().getAmountInDollars(),
          compareAtPrice: variant.getCompareAtPrice()?.getAmountInDollars(),
          availability: variant.getAvailability(),
          stockCount: variant.getStockCount(),
          images: variant.getImages(),
          weight: variant.getWeight(),
          dimensions: variant.getDimensions(),
          isDefault: variant.isDefault(),
          createdAt: variant.getCreatedAt().toISOString(),
          updatedAt: variant.getUpdatedAt().toISOString(),
          onStripe: variant.isOnStripe(),
          stripeInfo: variant.getStripeInfo(),
        })),
      };

      productDtos.push(productDto);
    }

    return productDtos;
  }
}
